import { createSlice } from "@reduxjs/toolkit";



export const nexSlice = createSlice({
    name: 'nex',
    initialState: {
        nex: 0
    },
    reducers: {
        setNexil: (state, action) => {
            state.nex = action.payload
        },
        redNex: (state, action) => {
               state.nex = action.payload - 1 
        }
    }
})


export const { setNexil, redNex } = nexSlice.actions
export default nexSlice.reducer